import {
    BusSelectedFromSidebarSource,
    segmentTrackBusSelectedFromSidebar
} from "analytics/analyticTrackEvents";
import { getLabelStyle, LabelStyleType } from "components/common/labels";
import { useFavoriteBuses } from "contexts/FavoriteBusesContext/FavoriteBusesContext";
import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import useSelectedBuses from "contexts/SelectedBusesContext/useSelectedBuses";
import React from "react";
import { ScopedBus } from "types/busType";
import FavoriteStar from "./FavoriteStar";
import FirstTag from "./FirstTag";
import "./index.scss";
import SecondTag from "./SecondTag";
import SubheadingText from "./SubheadingText";

const FAVORITE_STAR_SIZE = 12;

type BusItemProps = {
    readonly isLoading: boolean;
    readonly scopedBus: ScopedBus;
    // Which list this row sits in, for the selection event.
    readonly selectionSource: BusSelectedFromSidebarSource;
};

const BusItem: React.FC<BusItemProps> = (props) => {
    const { isLoading, scopedBus, selectionSource } = props;
    const { bus } = scopedBus;

    const { selectedBusesAtLocation, selectedFacility, selectSingleBus } =
        useSelectedBuses();
    const { generator, componentConfig } = useMapViewRoutingMetadata();
    const { isFavorite } = useFavoriteBuses();
    const busIsFavorite = isFavorite(bus.niraBusId);

    const labelStyle: LabelStyleType = getLabelStyle(
        componentConfig,
        generator,
        true
    );

    const possibleSelectedBusIds = [
        selectedBusesAtLocation?.selectedBusId,
        selectedFacility?.fromBusId,
        selectedFacility?.toBusId
    ];
    const isSelected = possibleSelectedBusIds.includes(bus.id);

    return (
        <div
            className={`BusItem-wrapper ${
                isSelected ? "BusItem-wrapper-selected" : ""
            }`}
            onClick={() => {
                selectSingleBus(bus.id);
                segmentTrackBusSelectedFromSidebar(scopedBus, selectionSource);
            }}
        >
            <div
                // Master's exact string when there is no star, with the flex
                // modifier appended only when one renders.
                className={`BusItem-display-name bp5-text-large ${
                    isLoading ? "bp5-skeleton" : ""
                }${busIsFavorite ? " BusItem-display-name--with-star" : ""}`}
            >
                {bus.busDisplayName}
                {busIsFavorite && (
                    <FavoriteStar
                        size={FAVORITE_STAR_SIZE}
                        filled={true}
                        className="BusItem-favorite-star"
                    />
                )}
            </div>
            <FirstTag
                scopedBus={scopedBus}
                isLoading={isLoading}
                labelStyle={labelStyle}
            />
            <SubheadingText scopedBus={scopedBus} isLoading={isLoading} />
            <SecondTag
                scopedBus={scopedBus}
                isLoading={isLoading}
                labelStyle={labelStyle}
            />
        </div>
    );
};

export default BusItem;
